(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-overlay"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.getElementById('newsletter-overlay');
    const closeLink = overlay ? overlay.querySelector('a') : null;
    const currentPath = window.location.pathname;
    const OVERLAY_SHOWN_KEY = 'newsletter_overlay_shown';
    const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

    function shouldShowOverlay() {
      const shownTimestamp = localStorage.getItem(OVERLAY_SHOWN_KEY);
      if (!shownTimestamp) return true;
      const elapsed = Date.now() - parseInt(shownTimestamp, 10);
      return elapsed > SEVEN_DAYS_MS;
    }

    function showOverlay() {
      overlay.style.display = 'flex';
      overlay.classList.add('fade-in');
      document.body.style.overflow = 'hidden';
      // Mark overlay as shown with current timestamp
      localStorage.setItem(OVERLAY_SHOWN_KEY, Date.now().toString());
    }

    function hideOverlay() {
      overlay.classList.remove('fade-in');
      overlay.classList.add('fade-out');
      setTimeout(function () {
        overlay.style.display = 'none';
        overlay.classList.remove('fade-out');
        document.body.style.overflow = 'auto';
      }, 300);
    }

    // Show overlay on homepage with 2 second delay, but only once per 7 days
    if (overlay && currentPath === '/') {
      if (shouldShowOverlay()) {
        setTimeout(showOverlay, 2000);
      }
    }

    // Handle close button
    if (closeLink) {
      closeLink.addEventListener('click', function (e) {
        // If not on newsletter page, close the overlay instead of redirecting
        if (currentPath !== '/pages/newsletter') {
          e.preventDefault();
          hideOverlay();
        }
      });
    }

    // Close overlay when clicking outside with fade out
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          hideOverlay();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('product-form');
    const variantIdInput = form ? form.querySelector('input[name="id"]') : null;
    const addToCartButton = form ? form.querySelector('.add-to-cart-button') : null;
    const priceElement = document.querySelector('.variant-price');

    const productDataEl = document.getElementById('product-data');
    if (!productDataEl) return;

    const product = JSON.parse(productDataEl.textContent);
    const selectedOptions = {};

    const currentVariant = product.selected_or_first_available_variant || product.variants[0];
    if (currentVariant && currentVariant.options) {
      currentVariant.options.forEach((value, index) => {
        selectedOptions[index + 1] = value;
      });
    }

    function isVariantAvailable(optionPosition, optionValue) {
      const testOptions = { ...selectedOptions };
      testOptions[optionPosition] = optionValue;

      const matchingVariant = product.variants.find((variant) => {
        return variant.options.every((optionValue, index) => {
          const pos = index + 1;
          return optionValue === (testOptions[pos] || selectedOptions[pos]);
        });
      });

      return matchingVariant && matchingVariant.available;
    }

    const variantOptions = document.querySelectorAll('.variant-option');

    variantOptions.forEach((option) => {
      const position = parseInt(option.dataset.optionPosition);
      const value = option.dataset.value;

      if (currentVariant && currentVariant.available && selectedOptions[position] === value) {
        option.classList.remove('text-grey');
        option.classList.add('text-black');
      }
    });

    variantOptions.forEach((option) => {
      const position = parseInt(option.dataset.optionPosition);
      const value = option.dataset.value;

      if (!isVariantAvailable(position, value)) {
        option.classList.add('cursor-not-allowed', 'line-through');
        option.classList.remove('cursor-pointer', 'hover:underline');
      }

      option.addEventListener('click', function () {
        if (!isVariantAvailable(position, value)) return;

        selectedOptions[position] = value;

        const selectedVariant = product.variants.find((variant) => {
          return variant.options.every((optionValue, index) => {
            return optionValue === selectedOptions[index + 1];
          });
        });

        if (selectedVariant && variantIdInput) {
          variantIdInput.value = selectedVariant.id;

          if (priceElement && selectedVariant.price) {
            const formattedPrice = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: product.price_currency || 'USD',
            }).format(selectedVariant.price / 100);
            priceElement.textContent = formattedPrice;
          }

          if (addToCartButton) {
            if (selectedVariant.available) {
              addToCartButton.disabled = false;
              addToCartButton.textContent = 'ADD TO CART';
            } else {
              addToCartButton.disabled = true;
              addToCartButton.textContent = 'SOLD OUT';
            }
          }
        }

        variantOptions.forEach((opt) => {
          if (opt.dataset.optionPosition === this.dataset.optionPosition) {
            opt.classList.remove('text-black');
            opt.classList.add('text-grey');
          }
        });
        this.classList.remove('text-grey');
        this.classList.add('text-black');
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const formData = new FormData(form);
        const button = form.querySelector('.add-to-cart-button');
        const originalText = button.textContent;

        button.textContent = 'ADDING...';
        button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error('Error:', error);
            button.textContent = originalText;
            button.disabled = false;
            alert('There was an error adding the item to your cart. Please try again.');
          });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
